import {
  serializable,
  alias,
  object,
  list,
  primitive,
  custom,
} from "serializr";

export class CustomTags {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("color", primitive()))
  color?: string;

  @serializable(alias("is_default", primitive()))
  is_default?: boolean;

  @serializable(alias("admin_id", primitive()))
  admin_id?: number;
}
